import { render, staticRenderFns } from "./PasswordReminder.vue?vue&type=template&id=94f34166&"
import script from "./PasswordReminder.vue?vue&type=script&lang=js&"
export * from "./PasswordReminder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports